export default __webpack_public_path__ + "static/media/victorian-cabinet.6273a280.png";